import { Mail, MessageCircle, MapPin } from "lucide-react";
import { Seo } from "@/components/site/Seo";
import { ScamWarning } from "@/components/site/ScamWarning";
import { QuoteForm } from "@/components/site/QuoteForm";
import { COMPANY, WHATSAPP_URL } from "@/lib/site";

export default function Contact() {
  return (
    <>
      <Seo title="Contact" description="Contact SLN Agro Exports by WhatsApp or email, or send a quote request for bananas, onions or pomegranates." path="/contact" />
      <section className="max-w-7xl mx-auto px-6 md:px-12 py-24 grid md:grid-cols-12 gap-12">
        <div className="md:col-span-5 space-y-8">
          <div className="space-y-4">
            <p className="text-xs uppercase tracking-[0.25em] text-emerald-800">Contact</p>
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-semibold tracking-tight">Talk to our export desk.</h1>
          </div>
          <div className="space-y-4">
            <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" data-testid="contact-whatsapp-btn"
              className="flex items-center gap-4 rounded-lg border border-stone-200 bg-white p-5 hover:border-green-500 transition-colors">
              <MessageCircle className="h-6 w-6 text-green-600" />
              <div><p className="font-medium">WhatsApp</p><p className="text-sm text-stone-500">{COMPANY.phoneDisplay}</p></div>
            </a>
            <a href={`mailto:${COMPANY.email}`} data-testid="contact-email-link"
              className="flex items-center gap-4 rounded-lg border border-stone-200 bg-white p-5 hover:border-emerald-700 transition-colors">
              <Mail className="h-6 w-6 text-emerald-800" />
              <div><p className="font-medium">Email</p><p className="text-sm text-stone-500">{COMPANY.email}</p></div>
            </a>
            <div className="flex items-center gap-4 rounded-lg border border-stone-200 bg-white p-5">
              <MapPin className="h-6 w-6 text-stone-500" />
              <div><p className="font-medium">Office</p><p className="text-sm text-stone-500">{COMPANY.address}</p></div>
            </div>
          </div>
          <ScamWarning />
        </div>
        <div className="md:col-span-7 rounded-lg border border-stone-200 bg-white p-6 md:p-10">
          <h2 className="text-2xl font-semibold mb-6">Request a quote</h2>
          <QuoteForm />
        </div>
      </section>
    </>
  );
}
